import React, { forwardRef } from 'react';

import { Box } from 'components/Box';
import { ClearButton } from 'components/Button';
import { Icon } from 'components/Icon';
import { LegacyInput } from 'components/LegacyInput';
import { TooltipStandalone } from 'components/TooltipStandalone';

import { LocationInputWrapper } from './LocationInputWrapper';

type Props = {
  showLocationIcon: boolean;
  onClear: (() => void) | null | undefined;
  className?: string;
  gMapsErrored: boolean;
  'data-qa-id': string;
  hasSuccess?: boolean;
};

export const StyledInput = forwardRef(
  (
    {
      showLocationIcon,
      onClear,
      className,
      gMapsErrored,
      ...inputProps
    }: Props,
    ref
  ) => (
    <LocationInputWrapper className={className}>
      {showLocationIcon && (
        <Box
          display="flex"
          alignItems="center"
          position="absolute"
          top={0}
          bottom={0}
          marginTop="auto"
          marginBottom="auto"
          left={9}
        >
          <Icon name="location" size={24} initialColorName="black" />
        </Box>
      )}

      <LegacyInput
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...inputProps}
        ref={ref}
        height="50px"
        width="100%"
        pt={showLocationIcon ? '13px' : undefined}
        pb={showLocationIcon ? '14px' : undefined}
        pl={showLocationIcon ? '39px' : '18px'}
        pr={onClear ? '38px' : '18px'}
      />

      {onClear && (
        <ClearButton
          onClick={onClear}
          data-qa-id={`${inputProps['data-qa-id']}-clear`}
        />
      )}

      {gMapsErrored && (
        <TooltipStandalone>
          {getText(
            'Our geolocation provider (Google Maps) did not load correctly. Please reload the page.'
          )}
        </TooltipStandalone>
      )}
    </LocationInputWrapper>
  )
);
